// My Returns loader (GW-471) — lazy-loads the direct-mount My-Returns widget
// bundle, twin of the quotes-list loader.
//
// GW builds a CORE "My Returns" page and drops:
//     <div data-pf-returns></div>
// This injects the self-contained React IIFE (public/js/returns-widget.js, CSS
// inlined), which mounts the returns list DIRECTLY into the div — no iframe. The
// heavy React bundle only loads on pages that carry the marker.
import { getTopDocument } from '../shared/dom.js';
import { getAppBaseUrl, getApiKey } from '../shared/config.js';

export var id = 'returns-list';

var WIDGET_FLAG = '__pfReturnsWidgetInjected';

export function init() {
  var doc = getTopDocument();
  var markers = doc.querySelectorAll('[data-pf-returns]');
  if (!markers || markers.length === 0) return;

  var win = doc.defaultView || window;

  try {
    if (!win.__PARTS_FINDER_APP_BASE_URL__) win.__PARTS_FINDER_APP_BASE_URL__ = getAppBaseUrl();
    if (!win.__PARTS_FINDER_API_KEY__) win.__PARTS_FINDER_API_KEY__ = getApiKey();
  } catch (e) { /* non-fatal */ }

  if (win[WIDGET_FLAG]) {
    try { if (win.PartsFinderReturns && win.PartsFinderReturns.autoMount) win.PartsFinderReturns.autoMount(); } catch (e) { /* ignore */ }
    return;
  }
  win[WIDGET_FLAG] = true;

  var src = getAppBaseUrl() + 'js/returns-widget.js';
  var s = doc.createElement('script');
  s.src = src;
  s.async = true;
  s.onload = function () {
    try { if (win.PartsFinderReturns && win.PartsFinderReturns.autoMount) win.PartsFinderReturns.autoMount(); } catch (e) { /* ignore */ }
  };
  s.onerror = function () {
    win[WIDGET_FLAG] = false;
    try { console.error('[parts-finder] failed to load returns widget bundle from ' + src); } catch (e) { /* ignore */ }
  };
  (doc.head || doc.getElementsByTagName('head')[0] || doc.body).appendChild(s);
}
